export const userEndpoints = (builder) => {
  return {
    login: builder.mutation({
      query: (credentials) => ({
        url: "/user/login",
        method: "post",
        credentials: "include",
        body: { ...credentials },
      }),
    }),
    register: builder.mutation({
      query: (credentials) => ({
        url: "/user/register",
        method: "post",
        credentials: "include",
        body: { ...credentials },
      }),
    }),
    version: builder.mutation({
      query: (credentials) => ({
        url: "/version",
        method: "get",
      }),
    }),
    getLoras: builder.query({
      query: () => ({
        url: `/user/avatars`,
        method: "get",
      }),
    }),
    getOrders: builder.query({
      query: () => ({
        url: `/user/orders`,
        method: "get",
        credentials: "include",
      }),
    }),
    getOrderDetails: builder.query({
      query: ({ _id }) => ({
        url: `/user/orders/${_id}`,
        method: "get",
        credentials: "include",
      }),
    }),
  };
};
